import ApiService from "../common/api.service";
import {
  GET_ACTIVITY_PER_CATEGORY,
  GET_BOOKINGS_OVERVIEW
} from "./actions.type";
import { GET_BOOKINGS_PER_CATEGORY } from "./actions.type";
import { GET_BOOKINGS_PER_FIELD } from "./actions.type";
import { GET_MOST_POPULAR_OVERVIEW } from "./actions.type";
import {
  SET_ACTIVITY_PER_CATEGORY,
  SET_BOOKINGS_OVERVIEW
} from "./mutations.type";
import { SET_BOOKINGS_PER_CATEGORY } from "./mutations.type";
import { SET_BOOKINGS_PER_FIELD } from "./mutations.type";
import { SET_MOST_POPULAR_OVERVIEW } from "./mutations.type";

const state = {
  activityPerCategory: null,
  bookingsPerCategory: [],
  bookingsPerField: [],
  mostPopularOverview: null,
  bookingsOverview: null,
  busiestHour: 0
};

const getters = {
  getActivityPerCategory: state => state.activityPerCategory,
  getBookingsPerCategory: state => state.bookingsPerCategory,
  getBookingsPerField: state => state.bookingsPerField,
  getMostPopularOverview: state => state.mostPopularOverview,
  getBookingsOverview: state => state.bookingsOverview,
  getBusiestHour: state => state.busiestHour
};

const actions = {
  async [GET_BOOKINGS_OVERVIEW]({ commit }, payload) {
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/home/booking-overview/${payload.time}`
    )
      .then(response => {
        commit(SET_BOOKINGS_OVERVIEW, response.data);
      })
      .catch(err => {
        console.log("ERR:: ", err);
      });
  },
  async [GET_ACTIVITY_PER_CATEGORY]({ commit }, payload) {
    let tempFootball = [];
    let tempHockey = [];

    let tempFitness = [];
    let tempAll = [];
    let currentHighest = { hour: 0, sum: 0 };
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/home/activity-per-category/total`
    ).then(response => {
      response.data.map(data => {
        let largest = Math.max.apply(null, [
          data.football,
          data.hockey,

          data.fitness
        ]);

        if (currentHighest.sum < largest) {
          currentHighest.sum = largest;
          currentHighest.hour = data.hour;
        }

        tempFootball.push(data.football);
        tempHockey.push(data.hockey);
        tempFitness.push(data.fitness);
      });

      tempAll.push(tempFootball);
      tempAll.push(tempHockey);

      tempAll.push(tempFitness);

      commit(SET_ACTIVITY_PER_CATEGORY, {
        bookings: tempAll,
        hour: currentHighest
      });
    });
  },

  async [GET_BOOKINGS_PER_CATEGORY]({ commit }, payload) {
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/home/bookings-per-category/${payload.time}`
    ).then(response => {
      let allBookings = [];
      let tempSoccerObj = {
        sport: "Football",
        bookings: response.data.football
      };
      let tempHockeyObj = {
        sport: "Hockey",
        bookings: response.data.hockey
      };

      let tempFitnessyObj = {
        sport: "Fitness",
        bookings: response.data.fitness
      };
      allBookings.push(tempSoccerObj);
      allBookings.push(tempHockeyObj);
      allBookings.push(tempFitnessyObj);

      commit(SET_BOOKINGS_PER_CATEGORY, allBookings);
    });
  },
  async [GET_BOOKINGS_PER_FIELD]({ commit }, payload) {
    let tempBookingsPerField = [];
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/home/bookings-per-field/${payload.time}`
    ).then(response => {
      response.data.map(data => {
        tempBookingsPerField.push(data);
      });

      commit(SET_BOOKINGS_PER_FIELD, tempBookingsPerField);
    });
  },
  async [GET_MOST_POPULAR_OVERVIEW]({ commit }, payload) {
    let tempObj = {};
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/home/most-popular-overview/${payload.time}`
    ).then(response => {
      tempObj = response.data;
      commit(SET_MOST_POPULAR_OVERVIEW, tempObj);
    });
  }
};

const mutations = {
  [SET_BOOKINGS_OVERVIEW](state, payload) {
    state.bookingsOverview = payload;
  },
  [SET_ACTIVITY_PER_CATEGORY](state, payload) {
    state.activityPerCategory = payload.bookings;
    state.busiestHour = payload.hour;
  },
  [SET_BOOKINGS_PER_CATEGORY](state, payload) {
    state.bookingsPerCategory = payload;
  },
  [SET_BOOKINGS_PER_FIELD](state, payload) {
    state.bookingsPerField = payload;
  },
  [SET_MOST_POPULAR_OVERVIEW](state, payload) {
    state.mostPopularOverview = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
